import { baseService } from "service/base";

class ReportingService {
  uptime(networkId, start, end) {
    return baseService.post("/api/report/uptime", {
      network_id: networkId,
      start: start,
      end: end,
    });
  }
  uptimeDevices(networkId, date) {
    return baseService.post("/api/report/uptime/devices", {
      network_id: networkId,
      date: date,
    });
  }

  uptimeDevice(deviceId, start, end) {
    return baseService.post("/api/report/uptime/device", {
      device_id: deviceId,
      start: start,
      end: end,
    });
  }

  applications(networkId, start, end) {
    return baseService.post("/api/report/applications", {
      network_id: networkId,
      start: start,
      end: end,
    });
  }

  applicationsDevices(networkId, date) {
    return baseService.post("/api/report/applications/devices", {
      network_id: networkId,
      date: date,
    });
  }

  applicationsDevice(deviceId, start, end) {
    return baseService.post("/api/report/applications/device", {
      device_id: deviceId,
      start: start,
      end: end,
    });
  }

  adDelivery(networkId) {
    return baseService.post("/api/report/ad-delivery", {
      network_id: networkId,
    });
  }
}

const reportingService = new ReportingService();
export { reportingService };
